import script from "./ConfigDispenser.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfigDispenser.vue?vue&type=script&setup=true&lang=js"

import "./ConfigDispenser.vue?vue&type=style&index=0&id=59980e60&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59980e60"]])

export default __exports__